import React from 'react';

const LakeIcon = (props) => {
  return (
    <img
      alt="Jezioro"
      src="/static/images/icons/place_types/lake.svg"
      {...props}
    />
  );
};

export default LakeIcon;
